import apiClient from '../apiClient.js'

export const namespaced = true

export const state = {
  userDetails: {
    imageUrl: '/images/default_user_icon.png',
    name: null,
    role: null,
    token: null,
  },
  isFetching: false,
  userDetailsWereFetched: false,
}

export const getters = {
  token(state) {
    return state.userDetails.token
  },
  role(state) {
    return state.userDetails.role
  }
}

export const mutations = {
  fetch: state => (state.isFetching = true),
  fetched: (state, data) => {
    state.userDetails = data
    state.isFetching = false
    state.userDetailsWereFetched = true
  },
  fetchError: (state, error) => {
    state.error = error
    state.isFetching = false
  },
}

export const actions = {
  maybeFetchUserDetails({ dispatch, state }) {
    if (!state.userDetailsWereFetched) return dispatch('fetchUserDetails')
  },

  async fetchUserDetails({ commit }) {
    commit('fetch')
    try {
      const result = await apiClient.get('/debug/userDetails')
      commit('fetched', result.data)
    } catch (e) {
      console.error('Error while fetching user details!')
      commit('fetchError', e)
    }
  },
}
